import "./lib/sessao-isolada";
import { instalarPonteBancoExterno } from "./lib/ponte-instalar";
import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Direciona as consultas ao banco escolhido antes de qualquer tela carregar.
  if (typeof window !== "undefined") instalarPonteBancoExterno();

  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    basepath: __CAMINHO__,
    scrollRestoration: false,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
